import { Box, Button, CircularProgress, Typography } from "@mui/material"
import { useNavigate } from "react-router"
import ProductsTable from "./ProductsTable"
import { useGetProductsQuery } from "@store/services/productsService"

export default function Products() {
  const { data: products, isFetching } = useGetProductsQuery({ roleHint: "" })
  const navigate = useNavigate()
  const onAddClick = () => navigate("/Administration/Products/new")

  return (
    <Box className={"admin-products"} sx={{ mt: 4 }}>
      <Typography variant="h4" sx={{ mb: 4 }}>
        Products
      </Typography>
      {isFetching ? (
        <Box sx={{ display: "flex", justifyContent: "center", my: 6 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <ProductsTable data={products?.items ?? []} />
          <Button sx={{ mt: 4 }} variant="contained" onClick={onAddClick}>
            Add Product
          </Button>
        </>
      )}
    </Box>
  )
}
